import { Component, ElementRef, OnInit } from "@angular/core";
import { ToastNotificationService } from "./toast-notification.service";

@Component({
  selector: 'toast-notification',
  templateUrl: './toast-notification.component.html',
  styleUrls: ['./toast-notification.component.scss']
})
export class ToastNotificationComponent {
  toastPosition: string = 'translate(0vw,0vh)';
  showsToast: boolean = false;
  toastClass: string[] = [];
  toastContent: string | undefined;
  count: number = 0;
  constructor(public toast: ToastNotificationService, private elementRef: ElementRef) {

  }
  public getImageForToast() {
    let value = this.toast.toastState$.value == 'success-toast' ? '../../../assets/icons/icon-done.svg' : this.toast.toastState$.value == 'warning-toast' ? '../../../assets/icons/icon-warning.svg' : this.toast.toastState$.value == 'rejected-toast' ? '../../../assets/icons/icon-rejected.svg' : this.toast.toastState$.value == 'caution-toast' ? '../../../assets/icons/icon-caution.svg' : this.toast.toastState$.value == 'information-toast' ? '../../../assets/icons/icon-information.svg' : '';
    return value;
  }

  // @HostListener('document:click', ['$event', '$event.target'])

  // public onClick(event: MouseEvent, targetElement: HTMLElement | null): void {

  //   if (!targetElement) {
  //     return;
  //   }



  //   const clickedInside = this.elementRef.nativeElement.contains(targetElement);

  //   if (!clickedInside) {
  //     if(this.toast.showsToast$.value){
  //       this.count++;
  //       setTimeout(() => {
  //         if(this.count >=2){            
  //           this.count = 0;
  //           //this.closeToast();
  //           //console.log(this.count);
  //         }
  //       }, 0);        
  //     //console.log('clicked');
  //     }
  //   }

  // }

  public onMouseDown(){
    this.toast.clearToastTimeout();
  }
  public onMouseUp(){
    this.toast.dismissToast();
  }

  public closeToast(){
    this.toast.dismissToast();
  }
}
